import { render, staticRenderFns } from "./EuropeanDetail.vue?vue&type=template&id=4d61db46&scoped=true"
import script from "./EuropeanDetail.vue?vue&type=script&lang=js"
export * from "./EuropeanDetail.vue?vue&type=script&lang=js"
import style0 from "./EuropeanDetail.vue?vue&type=style&index=0&id=4d61db46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d61db46",
  null
  
)

export default component.exports